module.exports = __webpack_public_path__ + "assets/e98cdd5517d2879b1cac7777a4382969.mp4";